module.exports = __webpack_public_path__ + "img/packages/v7.57d4da.png";